import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "../api";
import { useSession } from "../session";
import { ErrorNotice, Loading, Mark } from "../ui";

// "Sign in to the iPhone app as …?" Shown before the server hands the app a sign-in code, so a
// link alone can never sign an app in as you.

export function AppSignIn() {
  const { me, loading } = useSession();
  const [pending, setPending] = useState<boolean | null>(null);
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    api.get<{ pending: boolean }>("/auth/app/pending").then((r) => setPending(r.pending)).catch(setError);
  }, []);

  if (loading || pending === null) return error ? <ErrorNotice error={error} /> : <Loading />;
  if (!me) return <Navigate to={`/sign-in?returnTo=${encodeURIComponent("/app-sign-in")}`} replace />;

  return (
    <div className="center-page">
      <div className="signin stack" style={{ "--gap": "20px" } as React.CSSProperties}>
        <div className="row" style={{ justifyContent: "center" }}><Mark /><h1>TaxApp</h1></div>
        {!pending ? (
          <div className="notice">There's no iPhone sign-in waiting. Start again from the app.</div>
        ) : done ? (
          <div className="notice">Signed in. You can go back to the app.</div>
        ) : (
          <>
            <p>Sign in to the <strong>TaxApp iPhone app</strong> as <strong>{me.person.displayName}</strong>?</p>
            <p className="muted small">Only continue if you just tapped "Sign in" in the TaxApp app on your own phone. If you got here from a link, cancel.</p>
            <ErrorNotice error={error} />
            <button type="button" className="btn primary large" disabled={busy} onClick={async () => {
              setBusy(true);
              setError(null);
              try {
                const { location } = await api.post<{ location: string }>("/auth/app/approve");
                setDone(true);
                window.location.assign(location);
              } catch (e) {
                setError(e);
              } finally {
                setBusy(false);
              }
            }}>Sign in to the app</button>
            <a className="btn ghost" href="/">Cancel</a>
          </>
        )}
      </div>
    </div>
  );
}
